import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

class SignUpConfirmation extends Component {
  render() {
    const { config } = this.props;
    return (
      <div className="registerbg">
        <Helmet>
          <title>Sign Up Confirmation | {config.brand}</title>
          <link
            rel="canonical"
            href={window.location.origin.replace("beta", "www") + this.props.location.pathname}
          />
        </Helmet>

        <div className="Registration">
          <div className="Registration__info--sign-up-complete">
            <div className="Registration__sign-up-complete">Sign Up Complete</div>
            <p>
              Our compliance team will begin the approval process for your account shortly. Then your
              dedicated Account Manager will be in touch. Thank you for choosing CardCash.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({ config: state.config }))(SignUpConfirmation);
